module.exports = __webpack_public_path__ + "img/Roller.2b856c4d.png";